import React from 'react'
import translatePath from './translatePath'

export const defaultX = 0
export const defaultY = 0
export const width = 550
export const height = 1150

export const path = [
  'M275,0 C426.878306,0 550,123.121694 550,275 C550,296.858141 540.465079,317.616924 523.910924,331.857035 L523.407137,332.286553 L123.407137,670.286553 C75.1411927,711.071275 1.49048314,677.513945 0.0222955435,614.906054 L0,613 L0,275 C0,123.121694 123.121694,0 275,0 Z',
  'M275,150 C206.654762,150 151.120595,204.850715 150.016746,272.932896 L150,275 L150,451.433 L396.008,243.556 L395.877624,243.042473 C382.064401,190.655197 335.098297,151.727245 278.776659,150.055963 L277.067104,150.016746 L275,150 Z',
  'M275,200 L276.240262,200.010048 L276.957397,200.025046 C300.359166,200.624577 321.095224,211.943475 334.439884,229.255562 L334.842,229.782 L200,343.724 L200,275 L200.010048,273.759738 C200.665734,233.318922 233.329713,200.659002 273.772117,200.009848 L275,200 Z',
  'M549.977704,535.093946 L550,537 L550,875 C550,1026.87831 426.878306,1150 275,1150 C123.121694,1150 0,1026.87831 0,875 C0,853.141859 9.53492132,832.383076 26.0890761,818.142965 L26.5928631,817.713447 L426.592863,479.713447 C474.858807,438.928725 548.509517,472.486055 549.977704,535.093946 Z',
  'M400,698.565 L153.991,906.443 L154.122376,906.957527 C167.935599,959.344803 214.901703,998.272755 271.223341,999.944037 L272.932896,999.983254 L275,1000 C343.345238,1000 398.879405,945.149285 399.983254,877.067104 L400,875 L400,698.565 Z',
  'M350,806.275 L350,875 L349.989952,876.240262 C349.334266,916.681078 316.670287,949.340998 276.227883,949.990152 L275,950 L273.759738,949.989952 L273.042603,949.974954 C249.640834,949.375423 228.904766,938.056515 215.559146,920.743468 L215.157,920.217 L350,806.275 Z'
]

export const getPath = (x, y) => translatePath(path, defaultX, defaultY, x, y)

const ExclamationMark = () => (
  <symbol
    id="exclamation-mark"
    viewBox={`${defaultX} ${defaultY} ${width} ${height}`}
  >
    <path d={path.join(' ')} />
  </symbol>
)

export default ExclamationMark
